import React from 'react'

function Footer() {
    return (
        <footer className="p-4 bg-white shadow md:flex md:items-center md:justify-between md:p-6 dark:bg-gray-800">
            <div className="w-full text-center">
                <span className="text-sm text-gray-500 sm:text-center dark:text-gray-400">
                    © 2024 Purab Modi, All Rights Reserved.
                </span>
            </div>
        </footer>

    )
}


export default Footer

